module.exports = __webpack_public_path__ + "img/chat.ff2a1ac5.svg";